import createIcon from '../../createIcon';

/**
 * @component @name Start
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNTkgNy40MUwxOC4xNyAxMUg2VjEzSDE4LjE3TDE0LjU4IDE2LjU5TDE2IDE4TDIyIDEyTDE2IDZMMTQuNTkgNy40MVpNMiA2VjE4SDRWNkgyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Start = createIcon('Start', [
  [
    'path',
    {
      d: 'M14.59 7.41L18.17 11H6V13H18.17L14.58 16.59L16 18L22 12L16 6L14.59 7.41ZM2 6V18H4V6H2Z',
      key: 'v6m0mc',
    },
  ],
]);

export default Start;
